import { END_DATE, START_DATE } from '../constants/dateConstants';

const getIndexes = ({
  maxDaysAdvanceFromToday,
  minNights,
  focusedField,
  startDate,
  minNightsPerDate,
  allPossibleDatesAsStrings,
  maxNights,
}) => {
  let earliestAvailableIndex = 0;
  let latestAvailableIndex = maxDaysAdvanceFromToday - minNights;
  if (focusedField === END_DATE) {
    if (startDate) {
      const dateSpecificMinNights = minNightsPerDate[startDate] || minNights;
      const startDateIndex = allPossibleDatesAsStrings[startDate];
      earliestAvailableIndex = startDateIndex + dateSpecificMinNights;
      latestAvailableIndex = startDateIndex + maxNights;
    } else {
      earliestAvailableIndex = minNights;
      latestAvailableIndex = maxDaysAdvanceFromToday;
    }
  }
  return { latestAvailableIndex, earliestAvailableIndex };
};

const getAvailability = ({
  allPossibleDatesByIndex,
  datesAvailability,
  dateString,
  dateStringIndex,
  focusedField,
  minNights,
  minNightsPerDate,
  isInline,
}) => {
  const { isAvailableAsStartDate, isAvailableAsEndDate } = datesAvailability[dateString];

  if (focusedField === END_DATE && isAvailableAsEndDate) {
    return true;
  }
  if ((focusedField === START_DATE && isAvailableAsStartDate) || isInline) {
    let isAvailable = true;
    let baseIndex = 0;
    const minNightsForDate = minNightsPerDate[dateString] || minNights;
    while (baseIndex <= minNightsForDate && isAvailable) {
      const nextDate = allPossibleDatesByIndex[baseIndex + dateStringIndex];
      if (!datesAvailability[nextDate]?.isAvailableAsBridgingDate) {
        isAvailable = false;
      }
      baseIndex += 1;
    }
    return isAvailable;
  }
  return false;
};

const getIsSelected = (
  startDateIndex,
  dateIndex,
  endDateIndex
) => startDateIndex === dateIndex || endDateIndex === dateIndex;

const getIsBridging = (
  startDateIndex,
  dateIndex,
  endDateIndex) => dateIndex > startDateIndex && dateIndex < endDateIndex;

const isdateWithinCheckInLimit = ({
  isAvailable, calendarDateValue, checkinLimitValue, luxonStartDateValue,
}) => (!isAvailable && checkinLimitValue >= calendarDateValue
        && calendarDateValue > luxonStartDateValue) || calendarDateValue
        === luxonStartDateValue;

export {
  getIsBridging, getIsSelected, getAvailability, getIndexes, isdateWithinCheckInLimit,
};
